import { useRef, useEffect, useState } from 'react';
import ProductChart from './ProductChart';
import StrategicChart from './StrategicChart';
import ExecutionAIChart from './ExecutionAIChart';
import MarketPlanAIChart from './MarketPlanAIChart';
import { getSummary360DataAPI, getSummaryProductsAPI } from '../../../../service/ai-model.service';
import CustomLoader from '../../../../components/common/CustomLoader';
import { BasePageContainer } from '../../../../components/common';
import SalesFunnelWidget from '../sales-funnel/SalesFunnelWidget';
import { useAppContext } from '../../../../context/app.context';

const COLORS = ['red', 'green', 'blue', 'yellow', 'orange', 'teal'];

const getRandomColor = () =>
    COLORS[Math.floor(Math.random() * COLORS.length)];

const Summary360Table = () => {
    const tableRef = useRef(null);
    const [selectedProduct, setSelectedProduct] = useState('');
    const [productList, setProductList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [summaryData, setSummaryData] = useState(null);
    const { activeDashboardVersion } = useAppContext()
    const orgName = useRef('');

    useEffect(() => {
        const table = tableRef.current;
        const thEls = table.querySelectorAll("th");

        thEls.forEach((th) => {
            const resizer = document.createElement("div");
            resizer.classList.add("resizer");
            th.appendChild(resizer);

            let startX, startWidth;

            resizer.addEventListener("mousedown", (e) => {
                startX = e.clientX;
                startWidth = th.offsetWidth;

                const handleMouseMove = (e) => {
                    const newWidth = startWidth + (e.clientX - startX);
                    th.style.width = `${newWidth}px`;
                };

                const handleMouseUp = () => {
                    document.removeEventListener("mousemove", handleMouseMove);
                    document.removeEventListener("mouseup", handleMouseUp);
                };

                document.addEventListener("mousemove", handleMouseMove);
                document.addEventListener("mouseup", handleMouseUp);
            });
        });
    }, []);

    useEffect(() => {
        setLoading(true);
        if (activeDashboardVersion) {
            const params = new URLSearchParams(window.location.search)
            const org = params.get('org');
            getSummaryProductsAPI({ org, versionId: activeDashboardVersion })
                .then(r => {
                    if (r && r.length) {
                        const totalValue = r.reduce((a, i) => (a + i.value), 0);
                        r = r.map(i => ({ ...i, value: ((i.value / totalValue).toPrecision(2) * 100) }));
                        setProductList(r);
                        setSelectedProduct(r[0].name)
                    }
                })
                .catch(() => setLoading(false));
        }
        return () => { }
    }, [activeDashboardVersion]);

    useEffect(() => {
        if (selectedProduct) {
            const params = new URLSearchParams(window.location.search)
            const org = params.get('org');
            orgName.current = org;
            setLoading(true);
            getSummary360DataAPI({ product_name: selectedProduct, org, versionId: activeDashboardVersion })
                .then(d => setSummaryData(d))
                .catch(e => e)
                .finally(() => setLoading(false))
        }
    }, [selectedProduct]);

    const renderTableHeader = () => {
        return (
            <thead>
                {/*  Main header 1 */}
                {/* <tr className="main-header">
                    <th style={{ backgroundColor: '#795500' }} colSpan="2">Exploration</th>
                    <th style={{ backgroundColor: '#533a00' }} colSpan="2">Exploitation</th>
                </tr> */}
                {/*  Main header 2 */}
                <tr className="main-header">
                    <th style={{ backgroundColor: '#9747FF' }} colSpan="1">StrategicPlan.AI</th>
                    <th style={{ backgroundColor: '#7c2ee2' }} colSpan="1">Execution.AI</th>
                    <th style={{ backgroundColor: '#9747FF' }} colSpan="1">Markting.AI (Multiple Initiatives)</th>
                    <th style={{ backgroundColor: '#7c2ee2' }} colSpan="1">Sales.AI</th>
                </tr>
            </thead>
        );
    }

    const renderProductSelectBox = () => {
        return (
            <div className="form-group mb-0">
                <select className="form-control product-select"
                    id="product-select"
                    style={{ borderRadius: '50px', backgroundClip: "#F0F0F0" }}
                    value={selectedProduct}
                    onChange={(e) => setSelectedProduct(e.target.value)}>
                    <option value="" disabled>Select Product</option>
                    {productList.map((i, index) => <option value={i.name} key={`product-index-${index}`}>{i.name}</option>)}
                </select>
            </div>
        )

    }

    const renderStrageticTable = () => {
        const { recommendations } = summaryData;
        return (
            <table className='w-100 strategic-table mb-3'>
                <thead>
                    <tr>
                        <th style={{ width: '30%' }}>Initiative</th>
                        <th>Cost (M)</th>
                        <th>Benefit (M)</th>
                        <th>NPV (M)</th>
                        <th>Timeline (Months)</th>
                        <th>Grant Support</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        recommendations && recommendations.map((rec, index) => (<tr key={`row-${index}`}>
                            <td>{rec.name}</td>
                            <td>{rec.cost}</td>
                            <td>{rec.benefit}</td>
                            <td>{rec.npv}</td>
                            <td>{rec.time}</td>
                            <td>{rec.grant || '-'}</td>
                        </tr>)
                        )
                    }
                </tbody>
            </table >
        )

    }

    const renderStageticAIView = () => {
        return (
            <div className='d-flex flex-column gap-2'>
                <div className="row align-items-center py-2">
                    <div className="col-md-9">
                        {renderProdutDistribustion()}
                    </div>
                    <div className="col-md-3">{renderProductSelectBox()}</div>
                </div>
                <div className='strategic-chart-wrapper'>
                    <h3 className='chart-title mx-0'>Strategic Plan</h3>
                    <div className='col-md-12'>
                        <div className='strategic-chart-container'>
                            <StrategicChart data={summaryData.recommendations} />
                        </div>
                    </div>
                    <div className="col-md-12" >
                        {renderStrageticTable()}
                    </div>
                </div>
            </div>
        )
    }

    const renderProdutDistribustion = () => {
        return (
            <ProductChart data={productList} />
        )

    }

    const renderExecutionAIChart = () => {
        return (
            <div className='d-flex flex-column gap-2' style={{ marginTop: 80 }}>
                <div className='execution-chart-wrapper'>
                    <h3 className='chart-title mx-0'>Execition Plan</h3>
                    <div className='w-90 mx-auto mb-5'>
                        <ExecutionAIChart data={summaryData.development_data} stages={summaryData.development_stages} />
                    </div>
                </div>
            </div>

        )
    }

    const renderMarketAIChart = () => {
        return (

            <div className='d-flex flex-column gap-2' style={{ marginTop: 80 }}>
                <div className='execution-chart-wrapper'>
                    <h3 className='chart-title mx-0'>Marketing</h3>
                    <div className='w-90 mx-auto mb-5'>
                        <MarketPlanAIChart data={summaryData.market_data} stages={summaryData.market_stages} />
                    </div>
                </div>
            </div>

        )
    }

    const renderSalesAIChart = () => {
        if (summaryData && summaryData.client_stage_data) {
            const clients = summaryData.client_stage_data.map(c => ({ ...c, color: getRandomColor() }));
            return (
                <SalesFunnelWidget stages={summaryData.STAGES} clients={clients} orgName={orgName.current.replace('_', '')} />
            )
        }
        return <p className='d-flex align-items-center justify-content-center'>No data found</p>
    }

    const renderTableBody = () => {
        if (summaryData) {
            return (
                <tbody>{(
                    <tr style={{ verticalAlign: 'top' }}>
                        <td className='resizable-single-table'>
                            {renderStageticAIView()}
                        </td>
                        <td className='resizable-single-table'>
                            {renderExecutionAIChart()}
                        </td>
                        <td className='resizable-single-table'>
                            {renderMarketAIChart()}
                        </td>
                        <td className='resizable-single-table'>
                            {renderSalesAIChart()}
                        </td>
                    </tr>
                )}
                </tbody>
            );
        }
    }

    return (
        <div className="row mx-0 loginwrap">
            <BasePageContainer>
                {loading && <CustomLoader full />}
                <div className='resizable-table-container'>
                    <table ref={tableRef} className="resizable-table mb-4">
                        {renderTableHeader()}
                        {renderTableBody()}
                    </table>
                </div>
            </BasePageContainer>
        </div>
    );
}

export default Summary360Table;
